var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Router } from 'express';
import { getSha256Hash } from './util';
import { TwilioController, } from './twllio';
import { FlowController, defaultTestForExit, } from './Flows';
import { Message, Question, Reply, } from './Actions';
import { updateContext, } from './SmsCookie';
export { Flow, FlowSchema, } from './Flows';
export { Message, Question, Reply, Trigger, } from './Actions';
const cookieParser = require('cookie-parser');
const DEFAULT_EXIT_TEXT = 'Goodbye.';
const DELAY = process.env.NODE_ENV === 'test' ? 10 : 1000;
const ROUTE_REGEXP = /^\/?$/i;
function handleIncomingSmsWebhook(getUserContext, onCatchError, onMessage, fc, tc, req, res) {
    return __awaiter(this, void 0, void 0, function* () {
        let state = null;
        let userCtx = null;
        try {
            state = tc.getSmsCookieFromRequest(req);
            userCtx = yield getUserContext(req.body.From); // will throw any errors not caught in promise
            let action = yield fc.resolveActionFromState(req, state, userCtx);
            if (onMessage) {
                try {
                    const result = yield onMessage(state.interactionContext, userCtx, req.body.Body);
                    if (result instanceof Message) {
                        yield tc.sendMessageNotification(result);
                    }
                }
                catch (err) {
                    onCatchError(state.interactionContext, userCtx, err);
                }
            }
            while (action !== null) {
                yield tc.handleAction(req, action);
                yield new Promise(resolve => setTimeout(resolve, DELAY)); // for preserving message order
                state = yield fc.resolveNextStateFromAction(req, state, action);
                if ((state.isComplete)
                    || (action instanceof Question
                        && !action.isComplete))
                    break;
                action = yield fc.resolveActionFromState(req, state, userCtx);
                if (action === null)
                    break;
            }
            if (state.isComplete) {
                if (fc.onInteractionEnd !== null) {
                    try {
                        const result = yield fc.onInteractionEnd(state.interactionContext, userCtx);
                        if (result instanceof Message) {
                            yield tc.sendMessageNotification(result);
                        }
                    }
                    catch (err) {
                        onCatchError(state.interactionContext, userCtx, err);
                    }
                }
                tc.clearSmsCookie(res);
            }
            else {
                tc.setSmsCookie(res, state);
            }
            tc.sendEmptyResponse(res);
        }
        catch (err) {
            const result = yield onCatchError(state.interactionContext, userCtx, err);
            try {
                if (result instanceof Reply) {
                    yield tc.handleAction(req, result);
                    state = updateContext(state, fc.getCurrentFlow(state), result);
                }
                if (fc.onInteractionEnd !== null) {
                    yield fc.onInteractionEnd(state.interactionContext, userCtx);
                }
            }
            catch (innerErr) {
                yield onCatchError(state.interactionContext, userCtx, innerErr);
            }
            tc.clearSmsCookie(res);
            tc.sendEmptyResponse(res);
        }
    });
}
const defaultParameters = {
    cookieKey: null,
    cookieSecret: null,
    getUserContext: (() => null),
    onCatchError: (() => null),
    onInteractionEnd: null,
    onMessage: null,
    schema: null,
    sendOnExit: DEFAULT_EXIT_TEXT,
    testForExit: defaultTestForExit,
};
export function twilly({ accountSid, authToken, messagingServiceSid, root, schema = defaultParameters.schema, cookieKey = defaultParameters.cookieKey, cookieSecret = defaultParameters.cookieSecret, getUserContext = defaultParameters.getUserContext, onCatchError = defaultParameters.onCatchError, onInteractionEnd = defaultParameters.onInteractionEnd, onMessage = defaultParameters.onMessage, sendOnExit = defaultParameters.sendOnExit, testForExit = defaultParameters.testForExit, }) {
    if (!cookieKey) {
        cookieKey = getSha256Hash(accountSid, accountSid).slice(0, 16);
    }
    if (!cookieSecret) {
        cookieSecret = getSha256Hash(accountSid, authToken);
    }
    const fc = new FlowController(root, schema, {
        onInteractionEnd,
        testForExit,
    });
    const tc = new TwilioController({
        accountSid,
        authToken,
        cookieKey,
        messagingServiceSid,
        sendOnExit,
    });
    const router = Router();
    router.use(cookieParser(cookieSecret));
    router.post(ROUTE_REGEXP, handleIncomingSmsWebhook.bind(null, getUserContext, onCatchError, onMessage, fc, tc));
    return router;
}
